<div
     *ngIf="triggerWithCondition(card)"
     [attr.slug]="card['slug']">
    <test-user-card
            class="me-banners--item"
            [slug]="card['slug']"
            [callApi]="false"
            [blockData]="card"
            [notificationType]="card['content']['trigger']">
    </test-user-card>
</div>